import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const companyInfo = {
    name: 'DESi MART',
    tagline: 'Karlo Sapne Mutthi Me',
    description: 'Wealth · Family Happiness · Fulfilling Your Dreams',
    address: '123 Business Hub, Main Market, Delhi - 110001, India',
    phone: '+91-XXXXXXXXXX',
    email: 'info@desimart.com',
    website: 'https://www.desimart.net/'
  };

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/products', label: 'Products' },
    { path: '/plans', label: 'Our Plans' },
    { path: '/contact', label: 'Contact' },
    { path: '/login', label: 'Login' },
    { path: '/register?sponserid=DMC99999', label: 'Register' }
  ];

  const services = [
    { icon: '💊', label: 'Ayurvedic Health Supplements' },
    { icon: '🌶️', label: 'Premium Spices' },
    { icon: '🌾', label: 'Kitchen Essentials' },
    { icon: '🪔', label: 'Pooja Samagri' },
    { icon: '🥘', label: 'FMCG Products' },
    { icon: '💰', label: 'Business Opportunity' }
  ];

  const legalLinks = [
    { path: '/terms', label: 'Terms & Conditions' },
    { path: '/privacy', label: 'Privacy Policy' },
    { path: '/refund', label: 'Refund Policy' },
    { path: '/disclaimer', label: 'Disclaimer' }
  ];

  const socialLinks = [
    { icon: '📘', label: 'Facebook', url: '#' },
    { icon: '🐦', label: 'Twitter', url: '#' },
    { icon: '📷', label: 'Instagram', url: '#' },
    { icon: '💼', label: 'LinkedIn', url: '#' },
    { icon: '📺', label: 'YouTube', url: '#' },
    { icon: '📨', label: 'Email', url: `mailto:${companyInfo.email}` }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-5 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-white mb-2">{companyInfo.name}</h3>
              <p className="text-sm text-gray-400 mb-1">{companyInfo.tagline}</p>
              <p className="text-sm text-primary font-semibold">{companyInfo.description}</p>
            </div>
            
            <div className="space-y-2 text-sm">
              {/* <div className="flex items-center space-x-2">
                <span className="text-primary">📞</span>
                <span className="text-gray-300">{companyInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-primary">✉️</span>
                <span className="text-gray-300">{companyInfo.email}</span>
              </div> */}
              <div className="flex items-center space-x-2">
                <span className="text-primary">🌐</span>
                <span className="text-gray-300">{companyInfo.website}</span>
              </div>
            </div>

          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-primary transition-colors text-sm flex items-center space-x-2"
                  >
                    <span className="text-primary">→</span>
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index} className="flex items-center space-x-3">
                  <span className="text-primary text-lg">{service.icon}</span>
                  <span className="text-gray-300 text-sm">{service.label}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Social */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Legal & Social</h4>
            
            {/* Legal Links */}
            <div className="mb-6">
              <ul className="space-y-3">
                {legalLinks.map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.path}
                      className="text-gray-300 hover:text-primary transition-colors text-sm flex items-center space-x-2"
                    >
                      <span className="text-primary">📄</span>
                      <span>{link.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Social Links */}
            <div>
              <h5 className="text-sm font-semibold mb-3 text-gray-300">Follow Us</h5>
              <div className="grid grid-cols-3 gap-3">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center space-x-1 p-2 bg-gray-800 rounded-lg hover:bg-primary transition-colors text-xs"
                  >
                    <span>{social.icon}</span>
                    <span className="text-gray-300">{social.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Business Opportunity Banner */}
        <div className="mt-12 p-6 bg-gradient-to-r from-primary to-secondary rounded-lg text-center">
          <h3 className="text-xl font-bold mb-2">🚀 Join Our Business Opportunity</h3>
          <p className="text-sm mb-4">Start your journey to wealth, family happiness, and fulfilling your dreams!</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* <Link
              to="/register?sponserid=DMC99999"
              className="px-6 py-3 bg-white text-primary rounded-lg hover:bg-gray-100 transition-colors font-semibold"
            >
              Join Now
            </Link> */}
            <Link
              to="/plans"
              className="px-6 py-3 bg-transparent border-2 border-white text-white rounded-lg hover:bg-white hover:text-primary transition-colors font-semibold"
            >
              View Plans
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-gray-950 border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-5 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span>Designed with ❤️ in India</span>
              <span>•</span>
              <span>Powered by Innovation</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
